import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ListingTypeForm from '../../../components/forms/ListingTypeForm';
import { useCreateListingType } from '../../../hooks/useListingTypeApi';
import { useNavigate } from 'react-router-dom';
import { ListingTypeDTO } from '../../../services/apiClient';

const ListingTypeCreate: React.FC = () => {
  const navigate = useNavigate();
  const createMutation = useCreateListingType();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Listing Types', href: '/admin/listingtypes' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: ListingTypeDTO) => {
    try {
      setIsSubmitting(true);
      await createMutation.mutateAsync(data);
      navigate('/admin/listingtypes');
    } catch (error) {
      console.error('Error creating ListingType:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/listingtypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.ListingType.Edit"
    >
      <ListingTypeForm
        initialValues={{} as ListingTypeDTO}
        onSubmit={handleSubmit}
        onCancel={() => navigate('/admin/listingtypes')}
      />
    </AdminLayout>
  );
};

export default ListingTypeCreate;
